import { BookingEntity } from 'Models/Entities';
import passengerTypeStore from 'Models/PassengerTypeStore';
import { getMessageByKey } from 'Stores/LanguageStore';
import { getTotalPassengerCountFromBookingSummary } from 'Util/_HumanWritten/BookingEntity/GetTotalPassengerCount';
import { Tag } from 'Views/Components/_HumanWritten/CheckIn/FerryCheckIn/CheckInList/Tag';
import { CheckInBookingOverviewDto } from '../../CheckInEntities/CheckInBookingOverviewDto';
import { isNotNullOrUndefined, stringNotEmpty } from 'Util/TypeGuards';
import { FormatPhone } from 'Util/StringUtils';
import { getStopById } from 'Global/JourneyElements/Utils/getStopById';

export function transformPassengers(booking: BookingEntity | CheckInBookingOverviewDto) {
	const totalPassengerCount = getTotalPassengerCountFromBookingSummary(booking.bookedSummary);
	if (totalPassengerCount === 0) {
		return <Tag text={getMessageByKey('driverless-vehicle__tag', 'Driverless')} />;
	}
	return passengerTypeStore.getCheckInTableRow(booking.bookedSummary);
}

export function transformMobileNumber(booking: BookingEntity | CheckInBookingOverviewDto) {
	if (!booking.bookedSummary) {
		throw new Error('Booked summary missing');
	}

	const { bookedSummary } = booking;
	const isVehicleBooking = isNotNullOrUndefined(bookedSummary.cargoInfo);

	let phone;

	if (isVehicleBooking) {
		phone = bookedSummary.driverPhone;
	} else {
		phone = booking.user.phone;
	}

	if (phone === '' || phone === null) {
		return '-';
	}

	return FormatPhone(phone);
}

export function transformDestination(booking: BookingEntity | CheckInBookingOverviewDto) {
	if (!booking || !booking.bookedSummary) return '-';

	return getStopById(booking.bookedSummary?.endStopId)?.location?.shortName.toUpperCase() ?? '-';
}

/**
 * The account holder's company name. Shown in its own column on the desktop check-in table (the
 * mobile list appends it in brackets after the name instead), so the driver / booking name in the
 * name column is always kept.
 */
export function transformCompanyName(booking: BookingEntity | CheckInBookingOverviewDto) {
	const companyName = booking.user?.companyName?.trim();

	return stringNotEmpty(companyName) ? companyName : '-';
}

export function transformEmail(booking: BookingEntity | CheckInBookingOverviewDto) {
	if (!booking.bookedSummary) {
		throw new Error('Booked summary missing');
	}

	const { primaryEmail } = booking.bookedSummary;

	let email = null;

	if (stringNotEmpty(primaryEmail)) {
		email = primaryEmail;
	} else {
		email = booking.user.email;
	}

	if (email === '') {
		return '-';
	}

	return email;
}
